import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, addDays } from "date-fns";
import { getLabelFrom, validateCentralisedCampaignForm } from "../Validations";
// import SelectDropdown from "../../components-react/SelectDropdown";
import { broadcast_page_name } from "../../common-data/DropdowData";
import CmnFilters from "../../lead-management/common/CmnFilters";
import Loader from "../../ui/Loader";
import MultiSelect from "../../components-react/MultiSelect";
import BroadcastCampaignForm from "../../common-components/broadcast-template/BroadcastCampaignForm";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import {
  currentMonthCurrentDate,
  currentMonthEndDate,
  currentMonthStartDate,
  currentMonthTomorrowDate,
  currentMonthYesterdayDate,
  IS_LAST_DAY_OF_THE_MONTH,
  nextMonthEndDateFormatted,
} from "../../common-data/Converts";
import { ReloadIcon } from "../../../images/icons/icons";

const BroadcastForm = ({ closeModal, userInfoData, callFunction }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const forminitials = {
    selectedPageName: "",

    selectedMembers: [],
    totalMembers: 0,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const from = formValues.selectedPageName?.value || "";
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedGyms: [],
    isActive: "",
    selAddNotAddToLead: "",
    selectedODMStatus: "",
    selectedLMSSorting: "",
    selectedDateAddedSorting: "",
    selectedGender: "",
    selAutomationKeyword: "",
    selLeadStatus: "",

    selUTMSource: "",
    selUTMMedium: "",
    selUTMContent: "",
    selUTMTerm: "",
    selUTMCampaign: "",

    selAssignedLeadDay: "",
    selAssignedLeadHour: "",
    selAssignedLeadMinute: "",
    selAssignLeadFollowupDay: "",
    selAssignLeadFollowupHour: "",
    selAssignLeadFolloupMinute: "",

    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",

    searchString: "",

    selAssignee:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",

    selectedSubmissionType: "",

    selAddedby: "",
    selAssginee:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selCustomerIntent: "",
    selFollowupStatus: "",
    selLeadSource: "",
    selectedVendor: "",
    selCard: "",
    setPlan: "",
    selFollowupTime: [],
    selIsRaw: "",
    selLeadFrom: "",
    selFollowupStage: "",
    selOperatorValue: "",
    selConvertedIn: [],
    clickedCard: "",
    selectedWhatsappVerification: "",
    leadFollowupDateFrom: "",
    leadFollowupDateTo: "",
    leadClosureDateFrom: "",
    leadClosureDateTo: "",
    rawLeadAddDateFrom: "",
    rawLeadAddDateTo: "",

    selectedOtherUsers: "",
    selectedStartDate:
      formValues.selectedPageName?.value === "renewal_members"
        ? currentMonthTomorrowDate
        : currentMonthStartDate,
    selectedEndDate:
      formValues.selectedPageName?.value === "renewal_members"
        ? IS_LAST_DAY_OF_THE_MONTH
          ? nextMonthEndDateFormatted
          : currentMonthEndDate
        : formValues.selectedPageName?.value === "unpaid_members"
        ? currentMonthYesterdayDate
        : currentMonthCurrentDate,
    selectedTrxMode: "",
    selectedSubsType: "",
    selectedPlan: "",
    selectedRole: "",
    selRecurringStatus: "",
    selExpiringInDays: "",
    lastCheckedIn: "",
    selLeastCheckinInBetween: [],
    selExpiredDaysAgo: [],
    selButtonEnabled: "",
    selPaymentTimeSlot: [],
    selPaymentSource: "",
    selectedPriceRangeFrom: "",
    selectedPriceRangeTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: 1,
    limit: 5000,
    auto_gym_map: from === "wati" ? 1 : "",
    training_gym_data: from === "odm" ? 0 : "",
    filter_type:
      from === "unpaid_members" ||
      formValues.selectedPageName?.value === "unpaid_members"
        ? "unpaid"
        : from === "active_members"
        ? "active"
        : from === "expiring_today"
        ? "expire_today"
        : from === "expiring_this_month" ||
          formValues.selectedPageName?.value === "renewal_members"
        ? "expire_month"
        : "",

    gym_id: allFilters.selectedGym?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    plan_status: allFilters.isActive?.value || "",
    is_payment_done: allFilters.selectedODMStatus?.value || "",

    not_added_lms_sort: allFilters.selectedLMSSorting || "",
    date_added_sort: allFilters.selectedDateAddedSorting || "",
    gender: allFilters.selectedGender?.value || "",
    keyword_name: allFilters.selAutomationKeyword?.label || "",
    lead_status: allFilters.selLeadStatus?.value || "",

    utm_source: allFilters.selUTMSource?.value || "",
    utm_medium: allFilters.selUTMMedium?.value || "",
    utm_content: allFilters.selUTMContent?.value || "",
    utm_term: allFilters.selUTMTerm?.value || "",
    utm_campaign: allFilters.selUTMCampaign?.value || "",

    start_date:
      formValues.selectedPageName?.value === "renewal_members" ||
      formValues.selectedPageName?.value === "unpaid_members"
        ? allFilters.selectedStartDate || ""
        : allFilters.leadAddDateFrom || "",
    end_date:
      formValues.selectedPageName?.value === "renewal_members" ||
      formValues.selectedPageName?.value === "unpaid_members"
        ? allFilters.selectedEndDate || ""
        : allFilters.leadAddDateTo || "",
    convert_start_date: allFilters.leadConvertedDateFrom || "",
    convert_end_date: allFilters.leadConvertedDateTo || "",

    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    submission_type: allFilters.selectedSubmissionType?.value || "",
    assisted_by_id: allFilters.selAssignee?.value || "",

    assigned_to: allFilters.selAssginee?.value || "",
    added_by: allFilters.selAddedby?.value || "",
    follow_up_status: allFilters.selFollowupStatus?.value || "",
    source_name: allFilters.selLeadSource?.value || "",
    btl_vendor_id: allFilters.selectedVendor?.value || "",
    lead_type: allFilters.selCard?.value || "",
    intent_id: allFilters.selCustomerIntent?.value || "",
    plan_type: allFilters.setPlan?.value || "",
    is_raw_lead: allFilters.selIsRaw?.value || "",
    wap_image: allFilters.selectedWhatsappVerification?.value || "",
    follow_up_date_from: allFilters.leadFollowupDateFrom || "",
    follow_up_date_to: allFilters.leadFollowupDateTo || "",
    expected_closure_date_from: allFilters.leadClosureDateFrom || "",
    expected_closure_date_to: allFilters.leadClosureDateTo || "",
    rawlead_start_date: allFilters.rawLeadAddDateFrom || "",
    rawlead_end_date: allFilters.rawLeadAddDateTo || "",
    operator_value: allFilters.selOperatorValue?.value || "",

    sub_added_by: allFilters?.selectedOtherUsers?.value || "",
    trx_id: allFilters.selectedTrxMode?.value || "",
    membership_type: allFilters.selectedSubsType.value || "",
    plan_duration: allFilters.selectedPlan?.value || "",
    addon_cat_id:
      allFilters.selectedSubsType?.value === "addon" &&
      allFilters.selectedPlan?.value
        ? allFilters.selectedPlan.value
        : "",
    account_type: allFilters.selectedRole?.value || "",
    is_recurring: allFilters.selRecurringStatus?.value || "",
    last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
    expiring_indays: allFilters.selExpiringInDays?.value || "",
    expired_days_ago: "",
    is_btn_enabled: allFilters.selButtonEnabled?.value || "",
    payment_time_slot: "",
    payment_source: allFilters.selPaymentSource?.value || "",
    price_range_from: allFilters.selectedPriceRangeFrom?.value || "",
    price_range_to: allFilters.selectedPriceRangeTo?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const [allMembers, setAllMembers] = useState([]);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    if (name === "selectedPageName") {
      setAllFilters(iniAllFilter);
      setFormValues((prev) => ({
        ...prev,
        selectedMembers: [],
        totalMembers: 0,
        [name]: value,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleNextClick = () => {
    const errors = validateCentralisedCampaignForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setIsSubmit(true);
    }
  };

  const handleBackClick = () => {
    setIsSubmit(false);
  };

  function getMembers() {
    const endpoint = formValues.selectedPageName?.url;

    if (endpoint) {
      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: endpoint,
          payload: {
            filters: filters,
          },
          token: userInfoData?.token,
        })
      );
    }
  }

  useEffect(() => {
    getMembers();

    setFormValues((prev) => ({
      ...prev,
      selectedMembers: [],
      totalMembers: 0,
    }));
  }, [filters]);

  useEffect(() => {
    setAllFilters((prev) => {
      if (!prev.selectedGym) return prev;

      const filtered = prev.selectedGyms.filter(
        (gym) => gym?.value !== prev.selectedGym?.value
      );

      return {
        ...prev,
        selectedGyms: [prev.selectedGym, ...filtered],
      };
    });
  }, [allFilters.selectedGym]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym:
  //       !isAdmin && !isMarketing
  //         ? {
  //             label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //             value:
  //               userInfoData?.gym_id ||
  //               userInfoData?.user_id ||
  //               userInfoData?.uid ||
  //               "",
  //           }
  //         : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    const extractCheckinTimes = (checkinArray) => {
      let last_checkin_start_end_time = [];

      checkinArray?.length > 0 &&
        checkinArray.forEach((item) => {
          const itemValue = item.value;
          last_checkin_start_end_time.push(itemValue);
        });

      return {
        last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
      };
    };

    const extractExpiredDaysAgo = (arr) => {
      let days_ago = [];

      arr?.length > 0 &&
        arr.forEach((item) => {
          const itemValue = item.value;
          days_ago.push(itemValue);
        });

      return {
        days_ago: days_ago.join(", "),
      };
    };

    const extractPaymentTimes = (arr) => {
      let payment_times = [];

      arr?.length > 0 &&
        arr.forEach((item) => {
          const itemValue = item.value;
          payment_times.push(itemValue);
        });

      return {
        payment_times: payment_times.join(", "),
      };
    };

    const extractGyms = (arr) => {
      let gyms = [];

      arr?.length > 0 &&
        arr.forEach((item) => {
          const itemValue = item.value;
          gyms.push(itemValue);
        });

      return {
        gyms: gyms.join(", "),
      };
    };

    const { last_checkin_start_end_time } = extractCheckinTimes(
      allFilters.selLeastCheckinInBetween
    );
    const { days_ago } = extractExpiredDaysAgo(allFilters.selExpiredDaysAgo);

    const { payment_times } = extractPaymentTimes(
      allFilters.selPaymentTimeSlot
    );

    const { gyms } =
      allFilters.selectedGyms?.length > 0
        ? extractGyms(allFilters.selectedGyms)
        : allFilters.selectedGym?.value || "";

    setFilters((prev) => ({
      ...prev,
      auto_gym_map: from === "wati" ? 1 : "",
      training_gym_data: from === "odm" ? 0 : "",
      filter_type:
        from === "unpaid_members" ||
        formValues.selectedPageName?.value === "unpaid_members"
          ? "unpaid"
          : from === "active_members"
          ? "active"
          : from === "expiring_today"
          ? "expire_today"
          : from === "expiring_this_month" ||
            formValues.selectedPageName?.value === "renewal_members"
          ? "expire_month"
          : "",

      gym_id: gyms || allFilters.selectedGym?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      plan_status: allFilters.isActive?.value || "",
      is_payment_done: allFilters.selectedODMStatus?.value || "",

      not_added_lms_sort: allFilters.selectedLMSSorting || "",
      date_added_sort: allFilters.selectedDateAddedSorting || "",
      gender: allFilters.selectedGender?.value || "",
      keyword_name: allFilters.selAutomationKeyword?.label || "",
      lead_status: allFilters.selLeadStatus?.value || "",

      utm_source: allFilters.selUTMSource?.value || "",
      utm_medium: allFilters.selUTMMedium?.value || "",
      utm_content: allFilters.selUTMContent?.value || "",
      utm_term: allFilters.selUTMTerm?.value || "",
      utm_campaign: allFilters.selUTMCampaign?.value || "",

      start_date:
        formValues.selectedPageName?.value === "renewal_members" ||
        formValues.selectedPageName?.value === "unpaid_members"
          ? allFilters.selectedStartDate || ""
          : allFilters.leadAddDateFrom || "",
      end_date:
        formValues.selectedPageName?.value === "renewal_members" ||
        formValues.selectedPageName?.value === "unpaid_members"
          ? allFilters.selectedEndDate || ""
          : allFilters.leadAddDateTo || "",
      convert_start_date: allFilters.leadConvertedDateFrom || "",
      convert_end_date: allFilters.leadConvertedDateTo || "",

      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      submission_type: allFilters.selectedSubmissionType?.value || "",
      assisted_by_id: allFilters.selAssignee?.value || "",

      assigned_to: allFilters.selAssginee?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      follow_up_status: allFilters.selFollowupStatus?.value || "",
      source_name: allFilters.selLeadSource?.value || "",
      btl_vendor_id: allFilters.selectedVendor?.value || "",
      lead_type: allFilters.selCard?.value || "",
      intent_id: allFilters.selCustomerIntent?.value || "",
      plan_type: allFilters.setPlan?.value || "",
      is_raw_lead: allFilters.selIsRaw?.value || "",
      wap_image: allFilters.selectedWhatsappVerification?.value || "",
      follow_up_date_from: allFilters.leadFollowupDateFrom || "",
      follow_up_date_to: allFilters.leadFollowupDateTo || "",
      expected_closure_date_from: allFilters.leadClosureDateFrom || "",
      expected_closure_date_to: allFilters.leadClosureDateTo || "",
      rawlead_start_date: allFilters.rawLeadAddDateFrom || "",
      rawlead_end_date: allFilters.rawLeadAddDateTo || "",
      operator_value: allFilters.selOperatorValue?.value || "",

      sub_added_by: allFilters?.selectedOtherUsers?.value || "",

      trx_id: allFilters.selectedTrxMode?.value || "",
      membership_type: allFilters.selectedSubsType.value || "",
      plan_duration: allFilters.selectedPlan?.value
        ? allFilters.selectedPlan.value
        : "",
      addon_cat_id:
        allFilters.selectedSubsType?.value === "addon" &&
        allFilters.selectedPlan?.value
          ? allFilters.selectedPlan.value
          : "",
      account_type: allFilters.selectedRole?.value || "",
      is_recurring: allFilters.selRecurringStatus?.value || "",
      last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
      last_checkin_time_filter: last_checkin_start_end_time || "",
      expiring_indays: allFilters.selExpiringInDays?.value || "",
      expired_days_ago: days_ago || "",
      is_btn_enabled: allFilters.selButtonEnabled?.value || "",
      payment_time_slot: payment_times || "",
      payment_source: allFilters.selPaymentSource?.value || "",
      price_range_from: allFilters.selectedPriceRangeFrom?.value || "",
      price_range_to: allFilters.selectedPriceRangeTo?.value || "",
    }));
  }, [from, allFilters, formValues.selectedPageName]);

  useEffect(() => {
    if (from && !loading && !error && data?.status && data?.data) {
      const dropdownOptions = data.data?.map((item) => ({
        label: `${item.name || item.user_name || "NA"}/${
          item.mobile || item.user_mobile || ""
        }`,
        value:
          from === "wati" || from === "recurring" || from === "odm"
            ? item.uid
            : from === "lms"
            ? item.lead_id
            : item.user_id,
        info: item,
      }));

      setAllMembers(dropdownOptions);

      setFormValues((prev) => ({
        ...prev,
        totalMembers: data.data?.length,
      }));
    } else {
      setAllMembers([]);
      setFormValues((prev) => ({
        ...prev,
        selectedMembers: [],
        totalMembers: 0,
      }));
    }
  }, [data, loading, error, from]);

  console.log("formValues=> ", formValues.selectedPageName?.value);

  return (
    <div className="form-container boradcast-log-form">
      <form className="formContainer">
        {isSubmit ? (
          <BroadcastCampaignForm
            userInfoData={userInfoData}
            closeModal={closeModal}
            handleBack={handleBackClick}
            selectedMembers={formValues.selectedMembers}
            from={formValues.selectedPageName?.value}
            callFunction={callFunction}
            allFilters={allFilters}
          />
        ) : (
          <>
            <div className="formInputsGrid threeGridSystem mt15">
              <div className="formInputBox page-name-card span3">
                <label htmlFor="selectedPageName" className={`formInputLabel`}>
                  Select Audience Types{" "}
                  <small className="gray">
                    (Choose who should receive this broadcast)
                  </small>{" "}
                  <span className="required">*</span>
                </label>

                <div className="checkbox-group two-column-checkboxes">
                  {broadcast_page_name.map((option, idx) => (
                    <label
                      key={option.value}
                      className="checkbox-label page-card-checkbox-lable"
                    >
                      <input
                        type="checkbox"
                        checked={
                          formValues.selectedPageName?.value === option.value
                        }
                        onChange={() =>
                          onChangeDropdown(
                            formValues.selectedPageName?.value === option.value
                              ? ""
                              : option,
                            "selectedPageName"
                          )
                        }
                      />
                      <span className="custom-checkbox"></span>
                      {option.label}
                    </label>
                  ))}
                </div>

                {/* <div
                    className={`commonWrapper ${
                      formErrors.selectedPageName ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={broadcast_page_name}
                      selectedOption={formValues.selectedPageName}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedPageName")
                      }
                      name="Page"
                    />
                  </div> */}
              </div>
            </div>

            {formValues.selectedPageName?.value && (
              <>
                {formValues.selectedPageName?.value === "unpaid_members" ||
                formValues.selectedPageName?.value === "renewal_members" ? (
                  <CommonFilterStructure
                    from={"sales-table"}
                    isSegment={true}
                    decryptedText={userInfoData}
                    setFilters={setAllFilters}
                    filters={allFilters}
                    openDateRanger={openDateRanger}
                    onClickReset={onResetFilters}
                    handleDateRangeChange={handleDateRangeChange}
                    setOpenDateRanger={setOpenDateRanger}
                    rangeState={rangeState}
                    clearDateRanger={clearDateRanger}
                    clickedCard={
                      formValues.selectedPageName?.value === "unpaid_members"
                        ? "unpaid_members"
                        : formValues.selectedPageName?.value ===
                          "renewal_members"
                        ? "expiring_this_month"
                        : ""
                    }
                    otherUserLabel={
                      formValues.selectedPageName?.value === "unpaid_members" ||
                      formValues.selectedPageName?.value === "renewal_members"
                        ? "Added By"
                        : null
                    }
                  />
                ) : (
                  <CmnFilters
                    key={formValues.selectedPageName?.value}
                    from={
                      formValues.selectedPageName?.value === "odm" ||
                      formValues.selectedPageName?.value === "wati"
                        ? "one-day-membership"
                        : formValues.selectedPageName?.value === "lms"
                        ? "lead-management"
                        : formValues.selectedPageName?.value === "walkins"
                        ? "walkins-leads"
                        : formValues.selectedPageName?.value === "recurring"
                        ? "recurring-999"
                        : ""
                    }
                    selectedTab={
                      formValues.selectedPageName?.value === "odm"
                        ? 1
                        : formValues.selectedPageName?.value === "wati"
                        ? 2
                        : ""
                    }
                    isSegment={true}
                    isBroadcastLogs={true}
                    userInfoData={userInfoData}
                    onClickReset={onResetFilters}
                    filters={allFilters}
                    setFilters={setAllFilters}
                    clickedCard={
                      formValues.selectedPageName?.value === "wati"
                        ? "wati_leads"
                        : null
                    }
                    isReload={getMembers}
                  />
                )}
              </>
            )}

            <div className="formInputsGrid oneGridSystem">
              <div className={`formInputBox page-name-card`}>
                <div className="flexBetween">
                  <label htmlFor="selectedMembers" className={`formInputLabel`}>
                    choose {getLabelFrom(formValues.selectedPageName?.value)}{" "}
                    members{" "}
                    <small className="gray uppercase">
                      (total members: {formValues.selectedMembers?.length}/
                      {formValues.totalMembers})
                    </small>
                    {formErrors?.selectedMembers && (
                      <span className="required">*</span>
                    )}
                    <span 
                      className="broadcast-reload-icon"
                      onClick={getMembers}
                      title="Reload members data"
                    >
                      <ReloadIcon />
                    </span>
                  </label>

                  {formValues.selectedMembers?.length > 10 && (
                    <CloseSubmitBtn
                      submitLabel={"Next Review & Send"}
                      onSubmit={handleNextClick}
                      isLoading={loading}
                    />
                  )}
                </div>

                {loading ? (
                  <Loader />
                ) : (
                  <div
                    className={`commonWrapper no-border multi-select multi-show-option ${
                      formErrors?.selectedMembers ? "error" : ""
                    }`}
                  >
                    <MultiSelect
                      options={allMembers}
                      state={formValues.selectedMembers}
                      setState={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedMembers")
                      }
                      name="select multiple members from the list"
                      preventKeyboardOpen={false}
                      isShowList={true}
                    />
                  </div>
                )}

                <span className="tiny-info-label">
                  ⓘ Upto 5000 members can be fetched at a time!
                </span>
              </div>

              {/* <div className="formInputBox">
                  <label htmlFor="totalMembers" className={`formInputLabel`}>
                    total members
                  </label>

                  <input
                    type="number"
                    className={`formInput ${
                      formErrors?.totalMembers ? "formError" : ""
                    }`}
                    name="totalMembers"
                    value={formValues.totalMembers}
                    disabled
                  />
                </div> */}
            </div>

            <CloseSubmitBtn
              closeLabel="Cancel"
              submitLabel={"Next Review & Send"}
              onClose={closeModal}
              onSubmit={handleNextClick}
              isLoading={loading}
            />
          </>
        )}
      </form>
    </div>
  );
};

export default BroadcastForm;
